// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { FC } from "react";
// antd:
// import { Switch, Radio, Menu } from "antd";
// Components:
import DivE from "./DivE.tsx";
import OneSectionIcon from "./OneSectionIcon.tsx";
// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts"; // useAppDispatch
// Reducers:
import { getLng } from "../../libs/reducer.ts";
// Types
import type {TappSection, Tapp} from "../../types/uiapp.d.ts";

// const { rz } = window;

type componentProps = {
  section:TappSection,
  isExpanded:boolean,
  onToogle:(key:string) => void,
  onAppClick?:(e:React.MouseEvent) => void
};

const MainMenuSection:FC<componentProps> = ({section, isExpanded, onToogle, onAppClick}) => {
  // const dispatch = useAppDispatch();
  const lng = useAppSelector(getLng);

  return (
    <div id={"rzdesktopsection-" + section.key} className="" >
      <div id={"sectioncell-" + section.key} className="uk-card rz-borders-l6 rz-theme-transparent-hover-30 rz-width-expand rz-margin-8"
        style={{cursor: (isExpanded ? "auto" : "pointer"), borderRadius: "5px"}}
        onClick={() => { onToogle(section.key) }} >
          <h2 className="uk-card-media-top rz-margin-8 rz-width-expand">
            <DivE className="uk-grid uk-flex-middle" uk-grid="">
              <div className="rz-width-auto rz-margin-left-5">
                  <img className="uk-border-rounded" width={isExpanded ? "40" : "60"} height={isExpanded ? "40" : "60"} src={section.img} />
              </div>
              <div
                className="rz-width-expand rz-padding-left-10 uk-card-title uk-margin-remove-bottom rz-text-calc-height-8 rz-txt-gray"
                style={{fontSize: (isExpanded ? "0.7em" : undefined)}}
              >
                {section["title_" + lng]}
              </div>
            </DivE>
          </h2>
          { isExpanded && (
            <div
              className="uk-card-body uk-grid uk-child-width-1-4 uk-child-width-1-5@m uk-child-width-1-6@l uk-child-width-1-8@xl uk-text-center uk-padding-remove rz-margin-child-5">
                {section.apps.filter((aa:Tapp) => (!aa.type || ~["page", "link"].indexOf(aa.type))).map((aa) => (
                  <OneSectionIcon key={aa.key} app={aa} onAppClick={onAppClick} />
                ))}
            </div>
          )}
      </div>
    </div>
  );
}

export default MainMenuSection;
